import { getFileName, getFileType, truncateFileName } from "src/utils/common";
import { ButtonDownload } from "src/components/Common/Button";
import ProtectedComponent from "src/components/Permission";
import { FORM_NAME } from "src/pages/ProjectInstance/detail";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

export const columns = ({ t }) => [
  {
    dataField: `${FORM_NAME.FILES.UPDATED_AT}`,
    text: t(`detail.history_table.${FORM_NAME.FILES.UPDATED_AT}`),
    headerClass: "width-by-px-120 text-nowrap",
  },
  {
    dataField: "",
    text: t(`detail.history_table.${FORM_NAME.FILES.FILE_TYPE}`),
    headerClass: "width-by-px-100 text-nowrap",
    formatter: (_, row) => <span className="text-uppercase">{getFileType(row?.[FORM_NAME.FILES.FILE_TYPE])}</span>,
  },
  {
    dataField: `${FORM_NAME.FILES.FILE_NAME}`,
    text: t(`detail.history_table.${FORM_NAME.FILES.FILE_NAME}`),
    headerClass: "width-by-px-224 text-nowrap",
    formatter: (_, row) => {
      const fileName = getFileName(row?.[FORM_NAME.FILES.FILE_NAME]);
      return (
        <>
          <TooltipWrapper
            id={`tooltip-${FORM_NAME.FILES.FILE_NAME}-${row?.id}`}
            tooltipText={fileName || ""}
            checkOverflow={true}
            tooltipClassName="max-width-by-px-300"
          >
            <p className="mb-0 max-width-by-px-224 min-width-by-px-80 overflow-hidden text-truncate">
              {truncateFileName(fileName || "", 224)}
            </p>
          </TooltipWrapper>
        </>
      );
    },
  },
  {
    dataField: `${FORM_NAME.FILES.SOURCE}`,
    text: t(`detail.history_table.${FORM_NAME.FILES.SOURCE}`),
    headerClass: "width-by-px-120 text-nowrap",
  },
  {
    dataField: `${FORM_NAME.FILES.CHANGED_BY}`,
    text: t(`detail.history_table.${FORM_NAME.FILES.CHANGED_BY}`),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (_, row) => {
      const userName = row?.[FORM_NAME.FILES.CHANGED_BY];
      return (
        <>
          <TooltipWrapper
            id={`tooltip-${FORM_NAME.FILES.CHANGED_BY}-${row?.id}`}
            tooltipText={userName || ""}
            checkOverflow={true}
            tooltipClassName="max-width-by-px-300"
          >
            <p className="mb-0 max-width-by-px-160 min-width-by-px-80 overflow-hidden text-truncate">
              {truncateFileName(userName || "", 160)}
            </p>
          </TooltipWrapper>
        </>
      );
    },
  },
  {
    dataField: `${FORM_NAME.FILES.DEPLOYED_FOR_TEST}`,
    text: t(`detail.history_table.${FORM_NAME.FILES.DEPLOYED_FOR_TEST}`),
    headerClass: "width-by-px-160 text-nowrap",
    formatter: (_, row) => {
      const userInputId = row?.[FORM_NAME.FILES.DEPLOYED_FOR_TEST];
      if (!userInputId) {
        return <span>N/A</span>;
      }
      return (
        <>
          <TooltipWrapper
            id={`tooltip-${FORM_NAME.FILES.DEPLOYED_FOR_TEST}-${row?.id}`}
            tooltipText={userInputId || ""}
            checkOverflow={true}
            tooltipClassName="max-width-by-px-300"
          >
            <p className="mb-0 max-width-by-px-160 min-width-by-px-80 overflow-hidden text-truncate">
              {truncateFileName(userInputId || "", 160)}
            </p>
          </TooltipWrapper>
        </>
      );
    },
  },
  {
    dataField: "",
    text: t("detail.history_table.action"),
    headerClass: "width-by-px-60 text-nowrap",
    formatter: (_, row) => {
      return (
        <div className="d-flex justify-content-center align-items-center">
          <ProtectedComponent id={`ffile_history_download_${row?.id}`}>
            <ButtonDownload url={row?.s3_url} id={row?.id} handleDownload={() => window.open(row?.s3_url, "_blank")} />
          </ProtectedComponent>
        </div>
      );
    },
  },
];
